<template>
  <div id="app">
    <spinner :start="spin.value" />
    <transition name="fade" mode="out-in">
       <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Spinner from './components/ui-elements/Spinner.vue'

export default {
  name: 'App',
  components: {'spinner': Spinner},
  data: function(){
    return {
      spin: {value : false},
      modal : {value: false}
    } 
  },
  provide(){
    return {
      loading : this.spin,
      displayModal : this.modal
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue